import { useMutation } from "@apollo/client";
import { Form, Formik } from "formik";
import gql from "graphql-tag";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { handleGraphQLErrors } from "../../../utils/handleGraphQLError";
import { passwordValidator } from "../../../utils/passwordValidator";
import { Button } from "../../SharedComponents/Button/Button";
import { FormInput } from "../../SharedComponents/FormInput/FormInput";
import "../LoginForm/LoginForm.css";
import { LoginNewPasswordSuccess } from "./LoginNewPasswordSuccess/LoginNewPasswordSuccess";
import "./LoginSetNewPassword.css";

export const LoginSetNewPassword = () => {
  const { t } = useTranslation();
  /** @type {*} */
  const params = useParams();
  const [successDisplay, setSuccessDisplay] = useState(false);
  const [setNewPassword, { loading }] = useMutation(resetPasswordMutation);

  const newPasswordHandler = (password) => {
    setNewPassword({
      variables: { passwordResetValue: params.id, newPassword: password },
    })
      .then((data) => {
        if (data.data.resetSSOUserPassword === 1) {
          setSuccessDisplay(true);
        } else {
          setSuccessDisplay(false);
        }
      })
      .catch((err) => {
        handleGraphQLErrors(err);
      });
  };

  return (
    <div className="LoginSetNewPassword">
      {!successDisplay && (
        <Formik
          initialValues={{ password: "", confirmedPassword: "" }}
          onSubmit={(values) => newPasswordHandler(values.password)}
          validationSchema={validationSchema}
        >
          {() => (
            <Form>
              <FormInput
                name="password"
                type="password"
                label={t("generic.password")}
              />
              <FormInput
                name="confirmedPassword"
                type="password"
                label={t("loginForm.repeatPassword")}
              />
              <div className="LoginForm__submit">
                <div className="LoginForm__submit-button">
                  <Button
                    buttonStyle="Button__primary"
                    type="submit"
                    disabled={loading}
                  >
                    {t("generic.reset")}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
      {successDisplay && <LoginNewPasswordSuccess />}
    </div>
  );
};

const validationSchema = Yup.object().shape({
  password: passwordValidator.required("validation.passwordRequired"),
  confirmedPassword: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "loginForm.passwordNoMatch"
  ),
});

const resetPasswordMutation = gql`
  mutation resetSSOUserPassword(
    $passwordResetValue: String
    $newPassword: String
  ) {
    resetSSOUserPassword(
      passwordResetValue: $passwordResetValue
      newPassword: $newPassword
    )
  }
`;
